import Gallery from '@browniebroke/gatsby-image-gallery';
import { graphql } from 'gatsby';
import * as React from 'react';
export default {
  Gallery,
  graphql,
  React
};